<template>
  <form @submit.prevent="updateInfo" class="form">
    <label class="page__label">
      <span class="page__text">Имя</span>
      <input
        type="text"
        class="page__input"
        v-model="info.name"
        placeholder="Имя"
      />
    </label>
    <label class="page__label">
      <span class="page__text">phone</span>
      <input
        type="text"
        class="page__input"
        v-model="info.phone"
        placeholder="phone"
      />
    </label>
    <label class="page__label">
      <span class="page__text">position</span>
      <input
        type="text"
        class="page__input"
        v-model="info.position"
        placeholder="position"
      />
    </label>
    <label class="page__label">
      <span class="page__text">Права доступа</span>
      <select class="page__input" v-model="info.role">
        <option v-for="option in options" :key="option">{{ option }}</option>
      </select>
    </label>
    <label class="page__label">
      <span class="page__text">Аватарка url</span>
      <input type="url" class="page__input" v-model="info.url" />
    </label>

    <div class="row">
      <button class="btn btn-block" type="submit">
        Сохранить
      </button>
      <button class="btn btn-block" type="button" @click="resetInfo">
        Скинуть изменения
      </button>
      <button class="btn btn-block" type="button" @click="deleteUser">
        Удалить
      </button>
    </div>
  </form>
</template>

<script>
import firebase from "firebase";

export default {
  name: "User-item",
  props: {
    item: {
      type: Object,
      required: true
    },
    uid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      info: { ...this.item },
      options: ["user", "admin"]
    };
  },
  watch: {
    item() {
      this.resetInfo();
    }
  },
  methods: {
    updateInfo() {
      firebase
        .database()
        .ref(`users/${this.uid}`)
        .set({
          email: this.email,
          ...this.info
        })
        .then(() => {
          this.$emit("updateUsers");
        })
        .catch(alert);
    },
    resetInfo() {
      this.info = { ...this.item };
    },
    deleteUser() {
      firebase
        .database()
        .ref(`users/${this.uid}`)
        .set(null)
        .then(() => {
          this.$emit("updateUsers");
          alert("Теперь нужно удалить профиль в админке приложения firebase");
        })
        .catch(alert);
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2rem;
}
.row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 2rem;
}
</style>
